<template>
    <div class="header" :style="[{backgroundColor:headerBgc},{boxShadow:boxShadows}]">
        <div class="left">
        <!-- showLogo=true 时为深色 banner（白色 logo），Logo 组件 isShow 语义相反，需取反传入 -->
        <Logo :is-show="!showLogo" />
      </div>
      <!-- 中间的菜单项 -->
      <!-- <div class="center1">{{ $t('home') }}</div> -->
      <div class="center">
        <MenuItem @menuClick="menuClick" @titleClick="titleClick" :titleColor="titleColor"/>
      </div>
      <div class="right">
        <Lang :title-color="titleColor"/>
      </div>
    </div>
  </template>
  <script setup>
  import {ref,onMounted} from 'vue'
  import MenuItem from "./HeaderCom/MenuItem.vue";
  import Lang from "./HeaderCom/Lang.vue";
  import Logo from "./HeaderCom/Logo.vue";
  const localePath = useLocalePath()
  const headerH=ref(null)
  const router = useRouter()
  const props = defineProps({
    headerBgc:{
      type:String,
      default:'rgba(0, 0, 0, 0.04)'
    },
    boxShadows:{
      type:String,
      default:''
    },
    titleColor:{
      type:String,
      default:''
    },
    showLogo:{
      type:Boolean,
      default:true
    }
  })

  const emit = defineEmits(['titleClick','menuClick'])

  const menuClick=(item)=>{
    // console.log(item,'__)0');
    // if(item.id==1){
    //   router.push(`/about`)
    // }
    emit('menuClick',item.id,localePath(item.path))
  }
  const titleClick=(id)=>{
    const routeMap = {
      11: { id: '1', path: '/about' },
      22: { id: '6', path: '/product' },
      33: { id: '11', path: '/health' },
      44: { id: '13', path: '/contact' },
      55: { id: '0', path: '/newsCenter' },
    }
    const target = routeMap[id]
    if (target) {
      emit('menuClick', target.id, localePath(target.path))
    } else {
      emit('titleClick',id)
    }
  }
  onMounted(()=>{
  })
  </script>
  
  <style lang="less" scoped>
  .header {
    height: 36px;
    display: flex;
    align-items: center;
    position: fixed;
    z-index: 11;
    width: 100%;
    color: #fff;
    transition: background-color 0.6s ease, box-shadow 0.6s ease;
  .left{
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
  .right{
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
  .center{
    width: 60%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
  }
  </style>
  